import fetchClient from "api/client";
import SCHEDULED_REPORTS_ENDPOINT from "./scheduledReportsEndpoint";
/**
 * @description GET api/report-schedules
 * */
export default function getScheduledReports() {
  const url = `${SCHEDULED_REPORTS_ENDPOINT}`;

  return fetchClient.get(url);
}
